import React, { FC } from "react";

interface comparativeInter {
    title: string;
    tocomp: string;
    gallabox: string;
    tocomphtml?: any;
    gallaboxhtml?: any;
}
interface ComparativeType {
    comparative: comparativeInter[];
    compareWith: string;
}

const ComparisonTable: FC<ComparativeType> = ({ comparative, compareWith }) => {
    return (
        <>
            <h2 className="mb-10">
                <span className="capitalize">{compareWith}</span> vs Gallabox: A Comparative Table of Features, Offerings & More
            </h2>
            <span className="comp-pros-table mx-auto overflow-auto">
                <span className="comp-pros-table-grid p-1 rounded-xl">
                    <div className="grid-item-comp">Comparison</div>
                    <div className="grid-item-comp">
                        <img src={`comparison-page/${compareWith}-logo.png`} alt={`${compareWith} logo`} />
                    </div>
                    <div className="grid-item-comp">
                        <img src="comparison-page/gallabox-logo.png" alt="gallabox logo" />
                    </div>
                    {comparative?.map((data) => {
                        return (
                            <React.Fragment key={data.title}>
                                <div className="grid-item-comp leading-6">{data.title}</div>
                                <div className="grid-item-comp leading-6">
                                    {!(data.tocomp.split(".")[1] === "png") ? data.tocomphtml || data.tocomp : <img src={`comparison-page/${data.tocomp}`} alt="icon" />}
                                </div>
                                <div className="grid-item-comp leading-6">
                                    {!(data.gallabox.split(".")[1] === "png") ? data.gallaboxhtml || data.gallabox : <img src={`comparison-page/${data.gallabox}`} alt="icon" />}
                                </div>
                            </React.Fragment>
                        );
                    })}
                </span>
            </span>
        </>
    );
};

export default ComparisonTable;
